import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientTranslation } from '../../viewmodels/translation/client-translation';
import { CONFIG } from '../config';
import { ConfigService } from '../config.service';

@Injectable()
export class ClientTranslationService {

  constructor(private configService: ConfigService, private http: HttpClient) {
  }

  public async getClientNamespace(): Promise<string> {

    const configuration = await this.configService.getConfigurationAsync();
    const remoteConfigUrl = configuration.apiBaseUrl + '/' +
      CONFIG.apiRoutes.clientTranslation;

    return new Promise(resolve => {
      this.http.get(remoteConfigUrl).subscribe(
        (clientNamespace: ClientTranslation) => {
          resolve(clientNamespace.clientNamespace);
        });
    });
  }

}
